<template>
  <div id="news">
    <mNav></mNav>
    <mBanner></mBanner>
    <div class="news">
      <div class="news-container">
        <div class="news-b-title">企业新闻</div>
        <div class="news-list">
          <div class="item" v-for="item in newslist" :key="item.id">
            <a :href="'/#/m/detail/'+item.id">
              <div class="item-container">
                <img :src="item.image" alt="" />
                <div class="news-content">
                  <div class="news-content-container">
                    <div class="news-date">
                      <div class="year">{{item.year}}</div>
                      <div class="date">{{item.day}}</div>
                    </div>
                    <div class="news-content-main">
                      <div class="news-title">
                        {{item.newsname}}
                      </div>
                      <div class="news-text">
                        {{item.summary}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="more">
          <a href="">
            <img src="@/assets/imgs/more.png" alt="" />
          </a>
        </div>
      </div>
    </div>
    <mFooter></mFooter>
  </div>
</template>
    <script>
import mNav from "@/components/m/Nav";
import mBanner from "@/components/m/Banner";
import mFooter from "@/components/m/Footer";
export default {
  name: "mIndex",
  components: {
    mNav,
    mBanner,
    mFooter,
  },
  metaInfo: {
    title: "洋宇集团",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      newslist:[],
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    getData() {
      this.axios
        .get(this.$host + "/api/news/list")
        .then((res) => {
          this.newslist = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
  <style scoped>
.news {
  width: 100%;
}

.news-container {
  padding: 0 0.15rem 0.2rem 0.15rem;
}

.news .news-b-title {
    position: relative;
    padding: .25rem 0;
  text-align: center;
  font-size: 0.18rem;
  font-weight: 600;
  color: #000000;
}

.news .news-b-title::after{
    position: absolute;
    content: "";
    top:.55rem;
    left:calc(50% - .13rem);
    width:.26rem;
    height:.02rem;
    background: #ff0000;
}

.news .news-list {
  width: 100%;
}

.news .news-list .item {
  width: 100%;
  height: 2.45rem;
  margin-top: 0.1rem;
  background-color: #f7f7f7;
}

.news .news-list .item a {
  display: block;
  width: 100%;
  height: 100%;
}

.news .news-list .item a .item-container {
  padding: 0.1rem 0.1rem 0.14rem 0.1rem;
}

.news .news-list .item a img {
  width: 100%;
  height: 1.6rem;
}

.news .news-list .item .news-content {
  width: 100%;
  height: 0.75rem;
}

.news .news-list .item .news-content .news-content-container {
  padding: 0.14rem 0;
  display: flex;
  justify-content: space-between;
}

.news .news-list .item .news-content .news-date {
  width: 0.4rem;
}

.news .news-list .item .news-content .news-date .year {
  font-size: 0.19rem;
  font-family: Arial;
  font-weight: bold;
  color: #333333;
  border-bottom: 0.01rem solid #333333;
}

.news .news-list .item .news-content .news-date .date {
  width: 100%;
  text-align: center;
  font-size: 0.11rem;
  font-weight: 400;
  color: #666666;
}

.news .news-list .item .news-content .news-content-main {
  width: calc(100% - 0.5rem);
}

.news .news-list .item .news-content .news-content-main .news-title {
  height: 0.42rem;
  overflow: hidden;
  font-size: 0.16rem;
  font-weight: 600;
  color: #333333;
  line-height: 0.22rem;
}

.news .news-list .item .news-content .news-content-main .news-text {
  display: none;
  margin-top: 0.07rem;
  height: 0.26rem;
  overflow: hidden;
  font-size: 0.12rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.14rem;
}

.news .more {
  text-align: center;
  margin-top: 0.16rem;
}
</style>


// WEBPACK FOOTER //
// src/page/m/News.vue